import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'
import Home from '../views/Home.vue'

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { authRequired: true },
  },
  {
    path: "/login",
    name: "Login Screen",
    component: () =>
      import(
        "../views/login/LoginScreen.vue"
      ),
    meta: { authRequired: false },
  },
  {
    path: "/user/create",
    name: "Create User",
    component: () =>
      import(
        "../views/user/CreateUser.vue"
      ),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/user/edit/:id",
    name: "Edit User",
    component: () =>
      import("../views/user/EditUser.vue"),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/user/view/:id",
    name: "View User",
    component: () =>
      import("../views/user/ViewUser.vue"),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/site/create",
    name: "Create Site",
    component: () =>
      import(
        "../views/sites/CreateSite.vue"
      ),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/site/edit/:id",
    name: "Edit Site",
    component: () =>
      import("../views/sites/EditSite.vue"),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/site/type/create",
    name: "Create Site Type",
    component: () =>
      import(
        "../views/sites/CreateSiteType.vue"
      ),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/site/type/edit/:id",
    name: "Edit Site Type",
    component: () =>
      import(
        "../views/sites/EditSiteType.vue"
      ),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/site/management",
    name: "Site Management",
    component: () =>
      import(
        "../views/sites/ManagementSite.vue"
      ),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/user/management",
    name: "User Management",
    component: () =>
      import(
        "../views/user/ManagementUser.vue"
      ),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/site/type/management",
    name: "Site Type Management",
    component: () =>
      import(
        "../views/sites/ManagementSiteType.vue"
      ),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/notifications",
    name: "View Notifications",
    component: () =>
      import(
        "../views/notifications/ViewNotifications.vue"
      ),
    meta: { authRequired: true },
  },
  {
    path: "/notifications/management",
    name: "Manage Notifications",
    component: () =>
      import(
        "../views/notifications/ManageNotifications.vue"
      ),
    meta: { authRequired: true, adminRequired: true },
  },
  {
    path: "/notifications/create",
    name: "Create Notifications",
    component: () =>
      import(
        "../views/notifications/CreateNotifications.vue"
      ),
    meta: { authRequired: true, adminRequired: true },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.authRequired && !store.state.loggedIn) return next("/login");
  if (to.meta.adminRequired && !store.state.user.is_admin) return next("/");

  return next();
});

export default router
